// extracted by mini-css-extract-plugin
export default {"worksHeader":"works_worksHeader__qXdFA"};